export default __webpack_public_path__ + "static/media/credit.b922f1aa.svg";